import { jsx } from "react/jsx-runtime";
import "react";
import { Box } from "@zillow/constellation";
const MenuList = ({
  children,
  sx
}) => /* @__PURE__ */ jsx(Box, { as: "ul", sx: {
  alignItems: "end",
  listStyle: "none",
  padding: "$spacing.none",
  margin: "$spacing.none",
  ...sx
}, children });
export {
  MenuList as default
};
